import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { isLessThanBreakpoint } from 'dpl/util/grid';
import SmartImage from 'dpl/components/SmartImage';
import { sendAnalyticsEvent } from 'dpl/util/analytics';
import {
  ANALYTICS_EVENTS,
  ANALYTICS_VIEW_FEATURES,
  ANALYTICS_VIEWS
} from 'dpl/constants/analytics';
import usePopularBreeds from 'dpl/homepage/hooks/usePopularBreeds';
import { makeSequence } from 'dpl/shared/utils';
import SkeletonBlock from 'dpl/common/design_system/SkeletonBlock';

const IS_LT_MD = isLessThanBreakpoint('md');

function PopularBreedCard({ breed }) {
  function handleBreedClick(name) {
    sendAnalyticsEvent(ANALYTICS_EVENTS.BUTTON_CLICKED, {
      view: ANALYTICS_VIEWS.HOME,
      view_feature: ANALYTICS_VIEW_FEATURES.LEARN_ABOUT_POPULAR_BREEDS,
      button_cta: name
    });
  }

  return (
    <a
      href={breed.breed_overview_page_url}
      className="PopularBreedCard w-100 h-100 br12 overflow-hidden relative"
      onClick={() => handleBreedClick(breed.name)}
      target="_blank"
      rel="noopener noreferrer"
    >
      <div className="aspect-ratio aspect-ratio--5x6 relative z-0">
        <div
          className={classnames('aspect-ratio--object', {
            'transition grow': !IS_LT_MD
          })}
        >
          <SmartImage
            Tag="div"
            className="w-100 h-100 cover bg-center"
            src={breed.secondary_photo_url}
            loadingClass="bg-light-gray"
          />
        </div>
      </div>
      <p className="PopularBreedCard__name br10 absolute font-serif fw-medium font-20 ph4 pv4 bg-white">
        {breed.name}
      </p>
    </a>
  );
}

PopularBreedCard.propTypes = {
  breed: PropTypes.shape({
    name: PropTypes.string,
    secondary_photo_url: PropTypes.string,
    breed_overview_page_url: PropTypes.string
  }).isRequired
};

export default function PopularBreedCardSection() {
  const { isFetching, learnMorePopularBreeds } = usePopularBreeds();

  if (isFetching) {
    return (
      <div className="PopularBreedCardSectionSkeleton w-100">
        <div className="container-xl flex gap-12 md:gap-24 overflow-x-scroll no-scrollbars">
          {makeSequence(4).map(index => (
            <div
              key={index}
              className="PopularBreedCard overflow-hidden relative flex-1"
            >
              <div className="aspect-ratio aspect-ratio--5x6">
                <div className="aspect-ratio--object">
                  <SkeletonBlock className="br12 h-100" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="PopularBreedCardSection w-100">
      <div className="container-xl flex gap-12 md:gap-24 overflow-x-scroll no-scrollbars">
        {learnMorePopularBreeds.map(breed => (
          <PopularBreedCard key={breed.name} breed={breed} />
        ))}
      </div>
    </div>
  );
}
